import { useParams } from "react-router-dom"
import { useState, useRef, useEffect } from "react"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import "./ProductDetail.css"
import { motion, AnimatePresence } from "framer-motion"
import gsap from "gsap"

const BASE =
  "https://storage.googleapis.com/lenspublicnew/Smartvizx_website%20data/public";


const productData = {
  homes: {
    title: 'Homes',
    projects: [
      
        {
        slug: 'homes4',
        name: 'SDA',
        thumbnail: `${BASE}/ourproducts/sda/2.jpg`,
        images: [1, 2, 3, 4, 5].map(n => `${BASE}/ourproducts/sda/${n}.jpg`),
        description: 'A bespoke residence designed and built for Mr. Prem Singh Rana.',
      },
      {
        slug: 'homes2',
        name: 'NFC',
        thumbnail: `${BASE}/ourproducts/nfc.jpg`,
        images: [`${BASE}/ourproducts/nfc.jpg`],
        description: 'A bespoke residence designed and built for Mrs. Bagheria.',

      },
     
      //     {
      //   slug: 'homes3',
      //   name: 'Vasant Vihar',
      //   thumbnail: `${BASE}/ourproducts/upcoming.png`,
      //   images: [`${BASE}/ourproducts/up.png`],
      //   // description: '4.5 BHK Sample Apartment with stunning interior and FF&E design detailing and execution',

      // },
    ],
  },
  'experience-center': {
    title: 'Experience Center',
    projects: [
      {
        slug: 'exp',
        name: 'One DXP, SmartWorld Sales Gallery 111',
        thumbnail: `${BASE}/ourproducts/SmartWorldonedxp.png`,
        images: [1, 2, 3, 4, 5, 6, 7, 8].map(n => `${BASE}/ourproducts/onedxpp/${n}.jfif`),
        description: 'State of the art, grand and stunning sales gallery and experience center spread over two levels for One DXP project and other Smartworld projects in the vicinity.',

      },
        {
        slug: 'sample2',
        name: 'M3M Sales Gallery',
        thumbnail: `${BASE}/ourproducts/M3M.png`,
        images: [1, 2, 3, 4, 5, 6, 7, 8].map(n => `${BASE}/ourproducts/M3M/${n}.jfif`),
        description: '4 BHK Sample Apartment with bespoke interior and FF&E design detailing and execution',
      },
      {
        slug: 'exp2',
        name: 'AU Real Estate',
        thumbnail: `${BASE}/ourproducts/AURealestate.png`,
        images: [1, 2, 3, 4, 5, 6, 7, 8].map(n => `${BASE}/ourproducts/AUrealestate/AURealEstate/${n}.jfif`),
        description: ' Elegant, luxurious and inviting new sales gallery at Aditya World City for the new project launch.',

      },
      {
        slug: 'exp3',
        name: 'Trevoc Sales Gallery',
        thumbnail: `${BASE}/ourproducts/TREVOCLogo.jpg`,
        images: [
          `${BASE}/ourproducts/Trevoc/Trevoc/1.png`,
          `${BASE}/ourproducts/Trevoc/Trevoc/2.jfif`,
          `${BASE}/ourproducts/Trevoc/Trevoc/3.jfif`,
          `${BASE}/ourproducts/Trevoc/Trevoc/4.jfif`,
          `${BASE}/ourproducts/Trevoc/Trevoc/5.jfif`,
          `${BASE}/ourproducts/Trevoc/Trevoc/6.jfif`,
          `${BASE}/ourproducts/Trevoc/Trevoc/7.jfif`,
          
        ],
        description: 'Proposed Sales Gallery in Gurgaon',
      },
     
      {
        slug: 'exp5',
        name: 'ASF Experience Centre',
        thumbnail: `${BASE}/ourproducts/ASFLogo.jfif`,
        images: [
          `${BASE}/ourproducts/ASF/ASF/1.png`,
          `${BASE}/ourproducts/ASF/ASF/2.jfif`,
        ],
        description: 'Sales experience center for ASF in Gurgaon',
      },
    ],
  },
  offices: {
    title: 'Offices',
    projects: [
      {
        slug: 'offices1',
        name: 'Filatex Corporate Office',
        thumbnail: `${BASE}/ourproducts/FILATEX.png`,
        images: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(n => `${BASE}/ourproducts/Filatex/Filatex/${n}.jfif`),
        description: 'Elegance, understated luxury and functionality defined the design and build of this new corporate office for Filatex',
      },
    {
  slug: 'offices2',
  name: 'Upgrad',
  thumbnail: `${BASE}/ourproducts/Upgrad.png`,

  /* Hero image starts from Upgrad.png */
  images: [
    `${BASE}/ourproducts/UpGrad/UpGrad/upgrad.jpg`, // hero image first

    // `${BASE}/ourproducts/UpGrad/UpGrad/upgrad.jpg`,

    ...[2, 3, 4, 5, 6, 7].map(
      n => `${BASE}/ourproducts/UpGrad/UpGrad/${n}.jfif`
    )
  ],

  description:
    'Bright, cheerful, colourful and functional interiors for a very young workforce with a very high density of workstations.',
},
      {
        slug: 'offices3',
        name: 'ACS',
        thumbnail: `${BASE}/ourproducts/ACSlogo.jfif`,
        images: [1, 2, 3, 4, 5, 6].map(n => `${BASE}/ourproducts/ACS/${n}.jfif`),
        description: ' Complete building interiors with a different design concept for every floor in NOIDA for a global giant consulting firm',
      },
      // {
      //   slug: 'offices4',
      //   name: 'BMR Advisors',
      //   thumbnail: `${BASE}/ourproducts/BMRlogo.jpg`,
      //   images: [1, 2, 3, 4].map(n => `${BASE}/ourproducts/BMRAdvisors/BMRAdvisors/${n}.jfif`),
      //   description: 'Elegant Corporate office for a prestigious consulting firm acquired by Deloitte',
      // },
   {
  slug: "offices5",
  name: "InterOcean",
  thumbnail: `${BASE}/ourproducts/interOCEAN.jpg`,
  images: [1, 2, 3, 4, 5].map(
    n => `${BASE}/ourproducts/InterOcean/InterOcean/${n}.jfif`
  ),
  description:
    "Corporate office for a renowned shipping company in New Delhi",
},
      {
        slug: 'offices6',
        name: 'IFLY | Indigo',
        thumbnail: `${BASE}/ourproducts/Indigo.png`,
        images: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map(n => `${BASE}/ourproducts/IFlyIndigo/${n}.jfif`),
        description: 'New and state of the art training facility for Indigo Airlines with stunning interiors ',
      },
      {
        slug: 'offices7',
        name: 'Quickr Campus',
        thumbnail: `${BASE}/ourproducts/Quikrlogo.png`,
        images: [
          `${BASE}/ourproducts/QuikrCampus/QuikrCampus/main.jpg`,
          `${BASE}/ourproducts/QuikrCampus/QuikrCampus/2.jfif`,
          `${BASE}/ourproducts/QuikrCampus/QuikrCampus/3.jfif`,
          `${BASE}/ourproducts/QuikrCampus/QuikrCampus/4.jfif`,
          `${BASE}/ourproducts/QuikrCampus/QuikrCampus/5.jfif`,
          `${BASE}/ourproducts/QuikrCampus/QuikrCampusevoc/6.jfif`,
          `${BASE}/ourproducts/QuikrCampus/QuikrCampus/7.jfif`,
          `${BASE}/ourproducts/QuikrCampus/QuikrCampus/8.jfif`,
          `${BASE}/ourproducts/QuikrCampus/QuikrCampus/9.jfif`,
        ],
        description: 'Redevelopment of an old factory with amazing ceiling heights into the new corporate headquarters for Quickr.',
      },
      {
        slug: 'offices8',
        name: 'Bloomberg Quint',
        thumbnail: `${BASE}/ourproducts/bloomberglogo.jpg`,
        images: [1, 2, 3, 4, 5].map(n => `${BASE}/ourproducts/BloombergQuint/BloombergQuint/${n}.jfif`),
        description: 'New floor for Bloomberg Quint in Mumbai with studios, post production facilities and youthful interiors',
      },
      {
        slug: 'offices9',
        name: 'The Quint',
        thumbnail: `${BASE}/ourproducts/quint.png`,
        images: [1, 2, 3, 4, 5].map(n => `${BASE}/ourproducts/ThQuint/${n}.jfif`),
        description: 'Young, dynamic, eclectic interiors for The Quint in Noida',
      },
    ],
  },

    sample: {
    title: 'Sample apartment',
    projects: [
      {
        slug: 'Sample1',
        name: 'SmartWorld',
        thumbnail: `${BASE}/ourproducts/Smartworld.jfif`,
        images: [1, 2, 3, 4].map(n => `${BASE}/ourproducts/smartworldsample/${n}.jfif`),
        description: '4 BHK Sample Apartment with stunning interior and FF&E design detailing and execution',

      },
      
      //  {
      //   slug: 'sample3',
      //   name: 'Upcoming',
      //   thumbnail: '/ourproducts/upcoming.png',
      //   images: ['/ourproducts/up.png'],
      //   // description: '4.5 BHK Sample Apartment with stunning interior and FF&E design detailing and execution',

      // },
     
    ],
  },
};

export default function ProductDetail() {
  const { slug } = useParams()
  const heroRef = useRef()

  // ----------------------------
  // Determine category and project
  let initialCategory = null
  let initialProject = null

  if (productData[slug]) {
    // URL is a category
    initialCategory = productData[slug]
    initialProject = initialCategory.projects[0] // default first project
  } else {
    // URL is a project slug
    for (const catKey in productData) {
      const cat = productData[catKey]
      const found = cat.projects.find(p => p.slug === slug)
      if (found) {
        initialCategory = cat
        initialProject = found
        break
      }
    }
  }

  // ----------------------------
  // Hooks (always at the top!)
  const [category, setCategory] = useState(initialCategory)
  const [project, setProject] = useState(initialProject)
  const [activeImageIndex, setActiveImageIndex] = useState(0)
  const [fullscreen, setFullscreen] = useState(false)

  const images = project?.images || []

  // ----------------------------
  // Hero float motion
  useEffect(() => {
    if (!heroRef.current) return
    gsap.to(heroRef.current, {
      y: -18,
      duration: 4,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
    })
  }, [activeImageIndex])

  // ----------------------------
  // Zoom lens
  const handleMove = e => {
    if (!heroRef.current) return
    const rect = heroRef.current.getBoundingClientRect()
    const x = ((e.clientX - rect.left) / rect.width) * 100
    const y = ((e.clientY - rect.top) / rect.height) * 100
    heroRef.current.style.transformOrigin = `${x}% ${y}%`
  }

  // ----------------------------
  if (!project || !category) return <div>Project not found</div>

  return (
    <div className="lux-page">
      <Navbar />

      <main className="lux-container">
        {/* CATEGORY TITLE */}
        <h1 className="lux-title">{category.title}</h1>

        {/* LOGO RAIL */}
        <div className="logo-rail">
          <div className="logo-track">
            {[...category.projects, ...category.projects].map((p, i) => (
              <button
                key={i}
                className={`logo-chip ${p.slug === project.slug ? "active" : ""}`}
                onClick={() => {
                  setProject(p)
                  setActiveImageIndex(0)
                }}
              >
                <img src={p.thumbnail} />
              </button>
            ))}
          </div>
        </div>

        {/* PRODUCT REVEAL */}
        <section className="product-reveal">
          <div className="hero-wrapper">
            <motion.img
              key={images[activeImageIndex]}
              ref={heroRef}
              src={images[activeImageIndex]}
              className="hero-image"
              onMouseMove={handleMove}
              onMouseEnter={() => (heroRef.current.style.scale = 1.3)}
              onMouseLeave={() => (heroRef.current.style.scale = 1)}
              onClick={() => setFullscreen(true)}
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7 }}
            />
          </div>

          <div className="product-story">
            <h2>{project.name}</h2>
            <p>{project.description}</p>

            <div className="story-gallery">
              {images.map((img, i) => (
                <img key={i} src={img} onClick={() => setActiveImageIndex(i)} />
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* FULLSCREEN VIEWER */}
      <AnimatePresence>
        {fullscreen && (
          <motion.div
            className="fullscreen-viewer"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setFullscreen(false)}
          >
            <motion.img
              src={images[activeImageIndex]}
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}